import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import {
  LagerplatzUmlagerungConfig,
  SOFTLINE_CONFIG_LAGERPLATZ_UMLAGERUNG,
  SOFTLINE_PERMISSION_LAGERPLATZ_UMLAGERUNG,
} from './lagerplatz-umlagerung.shared';
import {
  provideSoftAppsModule,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { lagerplatzUmlagerungRoutes } from './lagerplatz-umlagerung.routes';

export const lagerplatzUmlagerungProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'lagerplatzUmlagerung',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#LAGERPLATZ_UMLAGERUNG.APP',
      description: '#LAGERPLATZ_UMLAGERUNG.APP_DESC',
      route: '/lagerplatz-umlagerung',
      icon: 'fa-regular fa-dolly',
      permission: SOFTLINE_PERMISSION_LAGERPLATZ_UMLAGERUNG,
      group: getModuleGroupByName('Lager'),
    });
  }),
];

export function providelagerplatzUmlagerungModule(config?: LagerplatzUmlagerungConfig) {
  const providers = provideSoftAppsModule(
    {
      name: 'lagerplatzUmlagerung',
      title: '#LAGERPLATZ_UMLAGERUNG.APP',
      route: '/lagerplatz-umlagerung',
      icon: 'fa-regular fa-dolly',
      permission: SOFTLINE_PERMISSION_LAGERPLATZ_UMLAGERUNG,
      group: getModuleGroupByName('Lager'),
    },
    withSoftAppsModuleRoutes({ app: lagerplatzUmlagerungRoutes }),
    withSoftAppsModuleTranslation({
      de: de,
    })
  );

  if (config) {
    providers.push({
      provide: SOFTLINE_CONFIG_LAGERPLATZ_UMLAGERUNG,
      useValue: config,
    });
  }
  return providers;
}
